import React, { useState } from "react";
import { NewPrefilter } from "../../../components/BuilderComponents/PreFilters/PreFilter";
import { ButtonStyles } from "../../../components/EditComponents/EditButtonConfig";
import Button from "../../../components/FormComponents/Button";
import Input from "../../../components/FormComponents/Input";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import BuilderRightSideBar from "../../../Layouts/BuilderRightSideBar";
import BuilderTabs from "../../../Layouts/BuilderTabs";

const ActivityCardEditActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button variant="secondary" size="small" onClick={() => setIsOpen(true)}>
        Edit
      </Button>

      <BuilderRightSideBar isOpen={isOpen} onClose={() => setIsOpen(false)} heading="Activity Card" size="small">
        <ActivityCardEditBar />
      </BuilderRightSideBar>
    </>
  );
};
const ActivityCardEditBar = () => {
  return (
    <BuilderTabs
      tabs={[
        { label: "Prefilter", content: <ActivityCardPrefilterEdit /> },
        { label: "General", content: <ActivityCardGeneralEdit /> }
      ]}
    />
  );
};

const ActivityCardGeneralEdit = () => {
  const { applicationBlockData, setApplicationBlockData } = useAppBlocksContext();

  const handleActivityCardInputs = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        config: {
          ...applicationBlockData.data.config,
          [name]: newValue
        }
      }
    });
  };
  const handleChangeButtonCnfig = (config) => {
    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        config: {
          ...applicationBlockData.data.config,
          non_perform_activity_button: config
        }
      }
    });
  };

  const handleButtonRefreshTime = (e) => {
    const { value } = e.target;
    const numericValue = Number(value);

    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        config: {
          ...applicationBlockData.data.config,
          non_perform_activity_button: {
            ...applicationBlockData.data.config.non_perform_activity_button,
            refresh_time: numericValue
          }
        }
      }
    });
  };

  return (
    <div className="builder_form p_3">
      <Input
        label="Placeholder"
        type="text"
        value={applicationBlockData?.data?.config?.non_perform_activity_message}
        name="non_perform_activity_message"
        onChange={handleActivityCardInputs}
        {...(applicationBlockData.device === "mobile" ? { placeholder: "Place Holder" } : {})}
      />
      <ButtonStyles
        buttonConfig={applicationBlockData?.data?.config?.non_perform_activity_button || {}}
        setButtonConfig={handleChangeButtonCnfig}
      />
      <Input
        label="Refresh Time (in milliseconds)"
        type="number"
        name="refresh_time"
        value={applicationBlockData?.data?.config?.non_perform_activity_button?.refresh_time}
        onChange={handleButtonRefreshTime}
        placeholder="e.g., 5000"
      />
      <Input
        type="checkbox"
        name="hide_activity_button"
        checked={applicationBlockData?.data?.config?.hide_activity_button}
        onChange={handleActivityCardInputs}
        label="Hide Button"
      />
      <Input
        type="checkbox"
        name="allow_activity_history"
        checked={applicationBlockData?.data?.config?.allow_activity_history}
        onChange={handleActivityCardInputs}
        label="Show history"
      />
    </div>
  );
};

const ActivityCardPrefilterEdit = () => {
  const { applicationBlockData, setApplicationBlockData } = useAppBlocksContext();
  const { data } = applicationBlockData;

  const handleChangePrefilter = (newPrefilter) => {
    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        ...newPrefilter
      }
    });
  };
  return (
    <div className="p_3">
      <NewPrefilter
        prefiltersWithFormula={{
          prefilter: data.prefilter || [],
          prefilters_joined_by: data.prefilters_joined_by || ""
        }}
        handleChange={handleChangePrefilter}
        tableId={data.table_id}
        folderIds={[data.activity_id]}
        tableType={"statemachine"}
      />
    </div>
  );
};

export default ActivityCardEditActions;
